import { useQuery } from '@tanstack/react-query';
import { getActiveImportId } from 'config/requests/bankOperations';

export const ACTIVE_IMPORT_ID_KEY = 'active_import_file';

export function useGetActiveImportId() {
  const { data, isLoading } = useQuery({
    queryKey: [ACTIVE_IMPORT_ID_KEY],
    queryFn: () => getActiveImportId(),
    retry: false,
  });

  return { data, isLoading };
}
